// Global Instructions Rule Applied!

import { DealRecord } from '../data_models/deal_record.ts'
import { TableFilterOptionsResponse } from '../rpc_models/get_table_filter_options_response.ts'
import { DealsPaginatedResponse } from '../../app_modules/deals/services/dealsService.ts'

export interface FilterValue {
  key: string
  /** `range` filters carry numbers; `date_range` filters carry ISO date strings (see cfg.reporting_column_defaults.filter_type). */
  value: string[] | string | { min?: number | string; max?: number | string }
}

export interface SortConfig {
  key: string
  direction: 'asc' | 'desc'
}

export interface PipelineState {
  filterOptions: TableFilterOptionsResponse
  activeFilters: FilterValue[]
  activeSorting: SortConfig[]
  data: DealRecord[]
}

export interface DealState {
  filterOptions: TableFilterOptionsResponse
  activeFilters: FilterValue[]
  activeSorting: SortConfig[]
  data: DealRecord[]
}

export interface MainState {
  pipeline: PipelineState
  deal: DealState
}

export enum DealTarget {
  PIPELINE = 'pipeline',
  DEAL = 'deal'
}

export interface SetFilterOptionsAction {
  type: 'deals/SET_FILTER_OPTIONS'
  payload: {
    response: TableFilterOptionsResponse
    target: DealTarget
  }
  [key: string]: any
}

export interface SetDealsAction {
  type: 'deals/SET_DEALS'
  payload: {
    response: DealsPaginatedResponse
    target: DealTarget
  }
  [key: string]: any
}

export interface SetActiveFiltersAction {
  type: 'deals/SET_ACTIVE_FILTERS'
  payload: {
    filters: FilterValue[]
    target: DealTarget
  }
  [key: string]: any
}

export interface SetActiveSortingAction {
  type: 'deals/SET_ACTIVE_SORTING'
  payload: {
    sorting: SortConfig[]
    target: DealTarget
  }
  [key: string]: any
}

export interface ClearActiveFiltersAction {
  type: 'deals/CLEAR_ACTIVE_FILTERS'
  payload: {
    target: DealTarget
  }
  [key: string]: any
}

export interface ClearActiveSortingAction {
  type: 'deals/CLEAR_ACTIVE_SORTING'
  payload: {
    target: DealTarget
  }
  [key: string]: any
}

export interface UpdateDealRecordAction {
  type: 'deals/UPDATE_DEAL_RECORD'
  payload: {
    dealId: string
    updates: Record<string, any>
  }
  [key: string]: any
}

export interface AddDealAction {
  type: 'deals/ADD_DEAL'
  payload: {
    deal: DealRecord
  }
  [key: string]: any
}

export interface UpdateDealRoundAction {
  type: 'deals/UPDATE_DEAL_ROUND'
  payload: {
    roundId: string
    updates: Record<string, any>
  }
  [key: string]: any
}

export interface RemoveDealFromListAction {
  type: 'deals/REMOVE_DEAL_FROM_LIST'
  payload: {
    dealId: string
  }
  [key: string]: any
}

export interface UpdateRecordBySearchAction {
  type: 'UPDATE_RECORD_BY_SEARCH'
  payload: {
    searchField: string
    searchValue: any
    updates: Record<string, any>
  }
  [key: string]: any
}

export type DealsAction =
  | SetFilterOptionsAction
  | SetDealsAction
  | SetActiveFiltersAction
  | SetActiveSortingAction
  | ClearActiveFiltersAction
  | ClearActiveSortingAction
  | UpdateDealRecordAction
  | AddDealAction
  | UpdateDealRoundAction
  | RemoveDealFromListAction
  | UpdateRecordBySearchAction
